import { create } from "zustand";

const useSpectraDeleteModalStore = create((set) => ({
  isOpen: false,
  spaceToDelete: null,
  callback: null,
  setIsOpen: (isOpen, spaceToDelete = null, callback = null) => {
    set({ isOpen, spaceToDelete, callback });
  },
}));

export default useSpectraDeleteModalStore;
